var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"breadcrumb"},[_c('div',{staticClass:"breadcrumb-box"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},_vm._l((_vm.dataList),function(item){return _c('el-breadcrumb-item',{attrs:{"to":{ path: item.path }}},[_vm._v(_vm._s(item.name)+"\n            ")])}),1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }